import '@angular/compiler';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withHashLocation, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideZonelessChangeDetection } from '@angular/core';

import { AppComponent } from './src/app.component';

import { APP_ROUTES } from './src/app.routes';
import { ErrorHandler } from '@angular/core';
import { GlobalErrorHandler } from './src/core/errors/global-error-handler';
import { resolveLegacyHashRedirectUrl } from './src/core/utils/legacy-app-link.util';

const legacyRedirectUrl = typeof window !== 'undefined'
  ? resolveLegacyHashRedirectUrl(window.location)
  : null;

if (legacyRedirectUrl && typeof window !== 'undefined') {
  window.location.replace(legacyRedirectUrl);
} else {
  bootstrapApplication(AppComponent, {
    providers: [
      provideZonelessChangeDetection(),
      provideRouter(
        APP_ROUTES,
        withHashLocation(),
        withInMemoryScrolling({
          anchorScrolling: 'enabled',
          scrollPositionRestoration: 'enabled'
        })
      ),
      provideHttpClient(),
      { provide: ErrorHandler, useClass: GlobalErrorHandler }
    ],
  }).catch((err) => console.error(err));
}

// AI Studio always uses an `index.tsx` file for all project types.
